import { unwrapResult } from "@reduxjs/toolkit"
import { Button, Col, Form, Modal, notification, Row, Upload } from "antd"
import { ReactElement, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styles from "./Putstorelist.module.css"
import _ from "lodash"
import { RootDispatch } from "../../app/store"
import React from "react"
import { UploadOutlined } from "../icons/Icons"
import { DownloadOutlined } from "@ant-design/icons"
import Dragger from "antd/lib/upload/Dragger"
import {
  getchargeExcel,
  getDentistHousekeeperExcel,
  getHerbsExcel,
  getpatientsDiagnosisExcel,
  getpatientsExcel,
  YunDiDrugImportExcelAsync,
  YunDiInventoryImportExcelAsync,
  YunDiMaterialImportExcelAsync,
  YunDiTreatmentImportExcelAsync
} from "./purchaseModalSlice"
import {getImportExcelAsync, orderImportExcelAsync} from "../../features/tenant/tenantSlice"

interface PurchaseModalProps {
  id?: string
  supplierId?: string
  isPurchaseModalVisible?: boolean
  state?: number
  onOk: () => void
  onCancel: () => void
}

export const PurchaseModal = ({
  id,
  supplierId,
  isPurchaseModalVisible,
  state,
  onOk,
  onCancel,
}: PurchaseModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<any>()

  const [btnLoading, setBtnLoading] = useState(false)


  const getUrl = (state?: number) => {
    switch (state) {
      case 1:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E6%82%A3%E8%80%85%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-20220711.xlsx?versionId=CAEQPxiBgID2pcayjxgiIGE5MzQ4ZDQwOGNiYzQ1ODg5MzU2ZmU5ZTYzMWYzMDk0'
      case 2:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E6%82%A3%E8%80%85%E8%AF%8A%E6%96%AD%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-20260720.xlsx'
      case 3:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E6%94%B6%E8%B4%B9%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-20220711.xlsx'
      case 4:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E8%AF%8A%E6%96%AD%E6%A8%A1%E6%9D%BF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-20220711.xlsx?versionId=CAEQPxiBgICCpsayjxgiIDFjMjBkYzVmYTQxYjQ3OTk4YjViZDk3ZTNhYzNhNDIw'
      case 5:
        return id ? 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E6%9C%BA%E6%9E%84%E8%8D%AF%E5%93%81-20220922.xlsx' : 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E9%A5%AE%E7%89%87%E5%8E%82%E8%8D%AF%E5%93%81-20220922.xlsx'
      case 6:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E5%A5%BD%E5%8C%BB%E7%82%B9%E6%89%B9%E9%87%8F%E5%BC%80%E6%88%B7%E6%A8%A1%E6%9D%BF-260630.xlsx'
      case 7:
        return 'https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/misc/%E5%90%8E%E5%8F%B0%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
    }
  }

  const submitBtn = () => {
    if (!fileList) return
    setBtnLoading(true)
    const params = {
      file: fileList,
      tenantId: id,
      supplierId: supplierId
    }
    switch (state) {
      case 1:    //患者导入
        dispatch(getpatientsExcel(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 2:  //患者诊断信息导入
        dispatch(getpatientsDiagnosisExcel(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 3:   //收费导入
        dispatch(getchargeExcel(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 4:  //牙医管家诊断模板导入
        dispatch(getDentistHousekeeperExcel(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 5:  //代煎饮片厂-商品目录-更新目录导入
        dispatch(getHerbsExcel(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 6:  //机构管理-导入
        dispatch(getImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 7:  //机构订单-导入
        dispatch(orderImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 8:  //云迪药品导入
        dispatch(YunDiDrugImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 9:  //云迪诊疗导入
        dispatch(YunDiTreatmentImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 10:  //云迪材料导入
        dispatch(YunDiMaterialImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
      case 11:  //云迪库存导入
        dispatch(YunDiInventoryImportExcelAsync(params))
          .then(unwrapResult)
          .then(successFn)
          .catch(errorFn)
        break
    }

  }
  const successFn = () => {
    setBtnLoading(false)
    notification.success({
      message: "导入成功",
      duration: 3,
    })
    onOk()
  }
  const errorFn = () => {
    setBtnLoading(false)
    onOk()
  }

  useEffect(() => {
    !isPurchaseModalVisible && setFileList(undefined)
  }, [isPurchaseModalVisible])
  return (
    <>
      <Modal
        className={styles.main}
        width={550}
        title={state ? '导入' : '导入库存'}
        okText='提交'
        footer={null}
        centered
        onOk={onOk}
        onCancel={onCancel}
        visible={isPurchaseModalVisible}
        destroyOnClose
      >
        <Form
          form={form}
          name='basic'
          autoComplete='off'

        >
          <Form.Item label='上传文件' style={{ margin: "25px" }}>
            <Dragger
              accept='.xls,.xlsx'
              maxCount={1}
              beforeUpload={(file) => {
                setFileList(file)
                return false
              }}
            >
              <div className={styles.upload}>
                <UploadOutlined mode='large'></UploadOutlined>
                <div>
                  将文件拖至此处，或{" "}
                  <span style={{ color: "#3894ff" }}>点击上传</span>
                </div>
              </div>
            </Dragger>
          </Form.Item>
          <Row style={{ marginBottom: "20px", marginTop: "-10px" }}>
            <p style={{ marginLeft: "90px" }}>只能上传.xls,.xlxs等文件</p>
            <a
              style={{ marginLeft: "140px" }}
              href={getUrl(state)}
              id='link1'
            >
              <DownloadOutlined />
              下载模板
            </a>
          </Row>
          <Form.Item>
            <Row gutter={20}>
              <Col span={12}>
                <Button
                  style={{ float: "right" }}
                  onClick={() => {
                    form.resetFields()
                    onCancel()
                  }}
                >
                  关闭
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  type='primary'
                  loading={btnLoading}
                  onClick={submitBtn}
                >
                  确认提交
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>

      </Modal>
    </>
  )
}
